import config from 'config';
import device from './device';
import safeLocalStorage from './safeLocalStorage';
import db8Storage from './db8Storage';
import { AsyncStorageLike } from './types';

const asyncLocalStorage: AsyncStorageLike = {
  getItem: async key => safeLocalStorage.getItem(key),
  setItem: async (key, value) => safeLocalStorage.setItem(key, value),
  removeItem: async key => safeLocalStorage.removeItem(key),
};

const getAppStorage = (): AsyncStorageLike =>
  device.isLG_WebOS && config.useDb8Storage ? db8Storage : asyncLocalStorage;

export default getAppStorage;
